import httpClient from "@/config/httpClient";
import { userStore } from "@/mobx/rootStore";

export async function storeToken(token) {
	httpClient.headers.Authorization = `Bearer ${token}`;
	userStore.token = token;

	await userStore.init();
	// await staticDataStore.init();
	// await businessStore.fetchList();
}
